import { forwardRef, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getTeamMemberSuggestionOptions } from './suggestions/team-member';

import {
  ClearFormattingToolbarSection,
  ListStyleToolbarSection,
  TextAlignToolbarSection,
  TextStyleToolbarSection,
} from '../StandaloneToolBar/sections/wysiwyg';
import { WYSIWYG } from './editor';
import { ToolbarWrapper } from '../StandaloneToolBar/styles';

import type { WYSIWYGProps, WYSIWYGHandle } from './types';

interface CommentEditorProps
  extends Pick<
    WYSIWYGProps,
    | 'onChange'
    | 'onBlur'
    | 'onFocus'
    | 'autofocus'
    | 'placeholder'
    | 'initialValue'
    | 'children'
    | 'zIndex'
  > {
  suggestionAppendToSelector?: string;
}

export const CommentEditor = forwardRef<WYSIWYGHandle, CommentEditorProps>(
  (
    {
      onChange,
      onBlur,
      onFocus,
      autofocus,
      placeholder,
      initialValue,
      suggestionAppendToSelector,
      children,
      zIndex
    },
    ref
  ) => {
    const queryClient = useQueryClient();

    const mentionOptions = useMemo(() => {
      return {
        suggestion: getTeamMemberSuggestionOptions(queryClient, {
          appendToSelector: suggestionAppendToSelector,
          zIndex
        }),
      };
    }, [queryClient, zIndex, suggestionAppendToSelector]);

    return (
      <WYSIWYG
        ref={ref}
        fitToContent={false}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        autofocus={autofocus}
        placeholder={placeholder}
        initialValue={initialValue}
        mentionOptions={mentionOptions}
        enableLists
        enableTextAlign
        enableTextStyles
        enableMentions
      >
        <ToolbarWrapper>
          <TextStyleToolbarSection />
          <TextAlignToolbarSection />
          <ListStyleToolbarSection />
          <ClearFormattingToolbarSection />
        </ToolbarWrapper>
        {children}
      </WYSIWYG>
    );
  }
);
